/*
 * Created Date: Monday, May 8th 2023
 * Author: Vive Vio Permana
 */

import IconVirtualRoom from "assets/icons/IconVirtualRoom"
import { ButtonPrimary } from "components/Common/Buttons"
import CopyToClipboardText from "components/Common/CopyToClipboardText"
import { useTranslation } from "react-i18next"
import { MdClear } from "react-icons/md"
import Swal from "sweetalert2"

const OpenBrowser = ({url}) => {

	const { t } = useTranslation();
    
    return <div className="luna-alert-content-container join-room">
        <div className="icon-close" onClick={Swal.close}>
            <MdClear />
        </div>
        <div className="icon-virtual-room">
            <IconVirtualRoom width={32} height={32}/>
        </div>
        <h5>{t('mediaform.openLinkdialog.title')}</h5>
        <p>{t('mediaform.openLinkdialog.description')}</p>
        <CopyToClipboardText url={url} />
        <div className="luna-alert-footer">
            <p>{t('mediaform.closeDialogText')}</p>
            <ButtonPrimary containerClass="btn-close-dialog" onClick={Swal.close}>{t('modalJoin.closeDialogButton')}</ButtonPrimary>
        </div>
    </div>
}

export default OpenBrowser
